// extracted by mini-css-extract-plugin
export default {"flex-center":"BigNumbersPriceBox_flex-center__R9G3T","flex-base":"BigNumbersPriceBox_flex-base__ZH86C","bold-text-value":"BigNumbersPriceBox_bold-text-value__69HtB"};